export default __webpack_public_path__ + "static/1875-554b1cd29a9617414d3aa32de13670bf.gif";